import { css } from '@emotion/react'
import { HFlow, Text } from 'bold-ui'
import { simNaoEnumToBoolean, TextField } from 'components/form'
import { RecordStringSelectField } from 'components/form/core/RecordStringSelectField/RecordStringSelectField'
import { QuantidadeAlimentacaoDiariaRadioGroupField } from 'components/form/field/QuantidadeAlimentacaoDiariaRadioField'
import { TempoSituacaoDeRuaRadioGroupField } from 'components/form/field/TempoSituacaoDeRuaRadioField'
import theme from 'config/theme'
import { MetaPath } from 'util/metaPath'
import { createFormSectionStyles } from 'view/cidadao/utils-cidadao'

import { FormRowSimNao } from '../../../../components/form/field/FormRowSimNao'
import { higienePessoalRecord, origemAlimentacaoRecord, SituacaoRuaFormModel } from '../types/model-cidadao'
import { FormSectionAccordionWithErrors } from './FormSectionAccordionWithErrors'

interface SituacaoRuaFormSectionProps {
  meta: MetaPath<SituacaoRuaFormModel>
  values: SituacaoRuaFormModel
}

export const SituacaoRuaFormSection = ({ meta, values }: SituacaoRuaFormSectionProps) => {
  const styles = createFormSectionStyles(theme)

  return (
    <FormSectionAccordionWithErrors
      name={meta.openedAccordion}
      title='Situação de rua'
      uuid='situacaoRua'
      textStyle={css`
        font-size: 1rem;
      `}
      panelStyle={styles.rowsContainer}
    >
      <HFlow>
        <Text fontWeight='bold'>Tempo de situação de rua</Text>
        <TempoSituacaoDeRuaRadioGroupField
          name={meta.tempoSituacaoRua}
          style={{
            ...styles.radioColumn('11rem'),
            hFlow: css`
              margin-right: -2.5rem;
            `,
          }}
        />
      </HFlow>

      <FormRowSimNao name={meta.recebeAlgumBeneficio} title='Recebe algum benefício?' clearable />
      <FormRowSimNao name={meta.possuiReferenciaFamiliar} title='Possui referência familiar?' clearable />

      <HFlow>
        <Text fontWeight='bold'>Quantas vezes se alimenta ao dia</Text>
        <QuantidadeAlimentacaoDiariaRadioGroupField
          name={meta.quantidadeAlimentacaoDiaria}
          style={{
            ...styles.radioColumn('11rem'),
            hFlow: css`
              margin-right: 0.5rem;
            `,
          }}
        />
      </HFlow>

      <HFlow>
        <Text fontWeight='bold'>Qual a origem da alimentação?</Text>
        <div css={styles.fixedWidthInputContainer}>
          <RecordStringSelectField
            name={meta.origemAlimentacao}
            record={origemAlimentacaoRecord}
            multiple
            label='Indique qual(is)'
            title='Indique qual(is)'
          />
        </div>
      </HFlow>

      <FormRowSimNao name={meta.possuiAcessoHigienePessoal} title='Tem acesso a higiene pessoal?' clearable>
        <div css={styles.fixedWidthInputContainer}>
          <RecordStringSelectField
            name={meta.higienePessoal}
            record={higienePessoalRecord}
            multiple
            required={simNaoEnumToBoolean[values?.possuiAcessoHigienePessoal] === true}
            disabled={simNaoEnumToBoolean[values?.possuiAcessoHigienePessoal] !== true}
            label='Indique qual(is)'
            title='Indique qual(is)'
          />
        </div>
      </FormRowSimNao>

      <FormRowSimNao name={meta.stAcompanhadoOutraInstituicao} title='É acompanhado por outra instituição?' clearable>
        <TextField
          name={meta.instituicaoAcompanhamento}
          label='Indique qual(is)'
          disabled={simNaoEnumToBoolean[values?.stAcompanhadoOutraInstituicao] !== true}
          style={styles.fixedWidthInputContainer}
        />
      </FormRowSimNao>

      <FormRowSimNao name={meta.visitaFamiliarComFrequencia} title='Visita algum familiar com frequência?' clearable>
        <TextField
          name={meta.grauParentescoVisitaFamiliar}
          label='Qual é o grau de parentesco?'
          disabled={simNaoEnumToBoolean[values?.visitaFamiliarComFrequencia] !== true}
          style={styles.fixedWidthInputContainer}
        />
      </FormRowSimNao>
    </FormSectionAccordionWithErrors>
  )
}
